module.exports = __webpack_public_path__ + "img/Type_Fire.c8510d3c.png";